import React from "react";
import styled from 'styled-components';
import ModalBase from "./base";

const NoMessage = (props) => {
  return (
    <ModalBase {...props}>
      <Inner>
        <p>お問い合わせいただいた各種サービスに関して、当社およびサービス提供会社からのご連絡がある場合のみご覧いただけます。</p>
        <div onClick={props.handleOnClose}>戻る</div>
      </Inner>
    </ModalBase>
  );
}

export default NoMessage;

const Inner = styled.div`
  position: absolute;
  width: 60%;
  background: white;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  padding: 4vw;
  border-radius: 2.6666667vw;
  text-align: center;
  p {
    margin-bottom: 4vw;
  }
  div {
    color: #c0c0c0;
  }
`;
